import HorariosPrestadores from "../../../pages/HorariosPrestadores/HorariosPrestadores";
import EstudiosPaciente from "../../../pages/Estudios/EstudiosPaciente";
import TurnosPaciente from "../../../pages/TurnosPaciente/TurnosPaciente";
import Configuraciones from "../../../pages/Configuraciones/Configuraciones";
import PageError from "../../../pages/PageError/PageError";
import MainPage from "../../../pages/MainPage/MainPage";
import NuevoTurno from "../../../pages/NuevoTurnoPrestacional/NuevoTurno";
import NuevoTurnoImagenes from "../../../pages/NuevoTurnoImagenes/NuevoTurnoImagenes";
import MisDatos from "../../../pages/MisDatos/MisDatos";

interface ContainerProps {
  name: string;
}

const ExploreContainer: React.FC<ContainerProps> = ({ name }) => {
  return (
    <div className="container">
      <div className="container">
        {(() => {
          switch (name) {
            case "Estudios":
              return <EstudiosPaciente />;
            case "Turnos":
              return <TurnosPaciente />;
            case "Horarios":
              return <HorariosPrestadores />;
            case "Reservar turno":
              return <NuevoTurno />;
            case "Reservar turnos imágenes":
              return <NuevoTurnoImagenes />;
            case "Datos":
              return <MisDatos />;
            case "Configuraciones":
              return <Configuraciones />;
            case "Inicio":
              return <MainPage />;
            default:
              return <PageError motivo="404" />;
          }
        })()}
      </div>
    </div>
  );
};

export default ExploreContainer;
